/**
 * article模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http2'; // 导入http中创建的axios实例
import store from '../store'
//import qs from 'qs'; // 根据需求是否导入qs模块,qs模块主要是为了对post请求时提交的数据进行一个qs序列化的处理,如果不进行处理 后端拿不到数据
//import { Search } from 'vant';

const search = {

    login(data) {
        return axios({
            url: `/api/v1/member/login`,
            method: 'post',
            data
        });
    },

    getCompany() {
        return axios({
            url: `/api/v1/company`,
            method: 'get',
        });
    },

    getCompanyByUser() {
        return axios({
            url: `/api/v1/company/member`,
            method: 'get',
        });
    },

    fontTransform(data) {
        return axios({
            url: `/api/v1/transform`,
            method: 'post',
            data
        });

    },
    fontReTransform(transformId) {
        return axios({
            url: `/api/v1/transform/retry/${transformId}`,
            method: 'put',
        });
    },
    fontDownload(transformId, srcOrDst) {
        return axios({
            url: `/api/v1/transform/download/${transformId}/${srcOrDst}`,
            method: 'get',
            responseType: 'blob'
        });
    },

    getTransformList(params) {
        return axios({
            url: `/api/v1/transform`,
            method: 'get',
            params
        });
    },

    getTransformListByBatch(params) {
        // 如果 fontName 为空，则从参数中移除
        const requestParams = { ...params };
        if (!requestParams.fontName || requestParams.fontName.trim() === '') {
            delete requestParams.fontName;
        }
        return axios({
            url: `/api/v1/transform/batch`,
            method: 'get',
            params: requestParams
        });
    },
    getMemberById(id) {
        return axios({
            url: `/api/v1/member/${id}`,
            method: 'get',
        });
    },
    update_user(data) {
        return axios({
            url: `/api/v1/member`,
            method: 'put',
            data
        });
    }


}

export default search;